import { Tabs } from "@jhool-io/fe-components";
import { useSearchParams } from "react-router-dom";
import { useFetchUserDetails } from "../../../../hooks/queries/user";
import Overview from "./Overview/Overview";

import { useAppSelector } from "../../../../hooks/useRedux";
import { cn } from "../../../../utils/helpers";
import useNewBackground from "../../../../hooks/useNewBackground";
import SuperviseeTasksWrapper from "./SuperviseeTasksWrapper/SuperviseeTasksWrapper";

export default function ProvidersDashboard() {
    const [searchParams, setSearchParams] = useSearchParams();

    const dashboardTabInView = searchParams.get("dashboard_view");

    const { practice } = useAppSelector((state) => state.userPractice);

    const userDetails = useFetchUserDetails();

    const useNewBg = useNewBackground();

    const handleSetTabInUrl = (view: string) => {
        searchParams.set("dashboard_view", view);
        setSearchParams(`dashboard_view=${view}`);
    };

    const tabItems = [
        {
            key: "overview",
            label: "Overview",
            children: <Overview />,
            onClick: () => handleSetTabInUrl("overview"),
        },
        {
            key: "supervisees_tasks",
            label: "Supervisor's Tasks",
            children: <SuperviseeTasksWrapper />,
            onClick: () => handleSetTabInUrl("supervisees_tasks"),
        },
    ];

    return (
        <div>
            <div className="flex items-center justify-between gap-16 flex-wrap">
                <div className="flex flex-col gap-y-8">
                    <h2
                        className={`text-xxl font-semibold ${
                            useNewBg ? "text-white" : "text-black"
                        }`}
                    >
                        Welcome back, {userDetails?.data?.first_name || ""}
                    </h2>
                    <span
                        className={`text-sm ${
                            useNewBg
                                ? "text-white"
                                : "text-[rgba(11,19,43,0.64)]"
                        } font-normal tracking-l_028`}
                    >
                        Review tasks and schedule your upcoming appointments.
                    </span>
                </div>
            </div>
            {practice?.is_supervisor ? (
                <div className="mt-28">
                    <Tabs
                        items={tabItems}
                        className={cn("!w-[100%] !items-end")}
                        defaultActiveKey={dashboardTabInView || "overview"}
                        size="medium"
                        mode={useNewBg ? "new" : "old"}
                    />
                </div>
            ) : (
                <div className="mt-28">
                    <Overview />
                </div>
            )}
        </div>
    );
}
